export default __webpack_public_path__ + "static/media/foto7.f921072e.jpg";